import ThumbZoomable from '~/components/ThumbZoomable'

const AssetPreview: React.FC<AssetPreviewProps> = ({ url, label }) => (
  <article className="d-flex flex-column gap-2">
    <strong>{label}</strong>
    <div className="d-flex flex-wrap gap-2">
      <ThumbZoomable url={url} title={label} size="medium" />
    </div>
  </article>
)

export default AssetPreview
